import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

function Loader() {
  return (
    <Box>
      <CircularProgress />
    </Box>
  );
}

export default Loader;